<template>
  <ContentSection :spacing="conditionalSpacing">
    <Container :indent="indent">
      <figure>
        <ImageDownloadable
          v-if="imageOrVideo.image"
          :image="imageOrVideo.image"
          :caption="data.caption"
          :downloadable="data.downloadable"
          :half-width="data.half_width"
        />
        <VideoPlayer
          v-else-if="imageOrVideo.video"
          :src="imageOrVideo.video"
          class="aspect-video w-full"
          :cover-image="imageOrVideo.cover_image"
          :youtube="{ controls: 1 }"
          keep-aspect-video
        />
        <figcaption
          v-if="data.caption"
          class="mt-4 max-w-text text-sm text-[#ABABAB]"
        >
          {{ data.caption }}
        </figcaption>
      </figure>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
  prevComponent: { type: String, default: null },
  nextComponent: { type: String, default: null },
})

const isNewsArticle = inject('isNewsArticle', null)
const isEvent = inject('isEvent', null)
const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)

/**
 * Return the first item of the image_or_video field
 * or false if it isn't an array
 */
const imageOrVideo = computed(() => {
  return props.data?.image_or_video?.[0] || false
})

const indent = computed(() => {
  if (isNewsArticle || isEvent || isSustainabilityArticleWithSidebar)
    return 'none'

  return 'center'
})

const conditionalSpacing = computed(() => {
  if (isNewsArticle || isEvent || isSustainabilityArticleWithSidebar)
    return 'sm'

  return useConditionalSpacing(props.prevComponent, props.nextComponent, [
    'custom_text',
    'custom_image_or_video',
  ]).value
})
</script>
